import { AxiosRequestConfig } from 'axios';
import queryString from 'query-string';

import Client from './client';

type Response = {
  readonly admin: boolean;
  readonly hasPhoneNumber: boolean;
  readonly message: string;
  readonly refreshToken: string;
  readonly result: string;
  readonly setupComplete: boolean;
  readonly status: number;
  readonly userId: string;
  readonly region: string;
};

export default (token: string, config?: AxiosRequestConfig) => {
  return Client.get<Response>(
    `/auth/v1/login/refresh?${queryString.stringify({
      token,
    })}`,
    config
  );
};
